/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'update';
const componentName = 'tech-support-wizard-page';
const prefix = `${moduleName}.${componentName}`;

export const transcriptLabel = `${prefix}.transcriptLabel`;
export const preCheckPendingLabel = `${prefix}.preCheckPendingLabel`;
export const progressMessage = `${prefix}.progressMessage`;
export const preCheckSuccessMessage = `${prefix}.preCheckSuccessMessage`;
export const preCheckFailureMessage = `${prefix}.preCheckFailureMessage`;
export const preCheckWarningMessage = `${prefix}.preCheckWarningMessage`;
export const preCheckPassSuccessLabel = `${prefix}.preCheckPassSuccessLabel`;
export const preCheckErrorLabel = `${prefix}.preCheckErrorLabel`;
export const preCheckPassWarningLabel = `${prefix}.preCheckPassWarningLabel`;
export const viewDetailsLabel = `${prefix}.viewDetailsLabel`;
export const errorLabel = `${prefix}.errorLabel`;
export const warningLabel = `${prefix}.warningLabel`;
export const successLabel = `${prefix}.successLabel`;
export const packageSuccessMessage = `${prefix}.packageSuccessMessage`;
export const packageCompletedWithWarningMessage = `${prefix}.packageCompletedWithWarningMessage`;
export const packageFailureMessage = `${prefix}.packageFailureMessage`;
export const packageWarningMessage = `${prefix}.packageWarningMessage`;

export const ENGLISH = {
    [transcriptLabel]: 'Transcript',
    [preCheckPendingLabel]: 'Pending',
    [progressMessage]: 'This may take a couple of minutes. You may close the wizard and continue working. To check on progress you can re-access from \'In progress\' tile or upon completion from \'Recent\' tiles on the right.',
    [preCheckSuccessMessage]: 'Pre-check completed successfully',
    [preCheckFailureMessage]: 'Pre-check failed',
    [preCheckWarningMessage]: 'Pre-check came back with warnings',
    [packageSuccessMessage]: 'Package completed successfully',
    [packageCompletedWithWarningMessage]: 'Package completed with warnings',
    [packageFailureMessage]: 'Package failed',
    [packageWarningMessage]: 'Package came back with warnings',
    [preCheckPassSuccessLabel]: 'Passed Successfully',
    [preCheckErrorLabel]: 'An error occurred during pre-check: {0}',
    [preCheckPassWarningLabel]: 'Passed With Warning',
    [viewDetailsLabel]: 'View Details',
    [errorLabel]: 'Errors ({0})',
    [warningLabel]: 'Warnings ({0})',
    [successLabel]: 'Successful ({0})',
};
